import { Icon } from '@easy-expense/ui-shared-components';
import { theme } from '@easy-expense/ui-theme';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

import { Button } from '../../Button.components';

export const AlertBanner: React.FC<{
  title: string;
  description: string;
  ctaLabel: string;
  onPress: () => void;
}> = ({ title, description, ctaLabel, onPress }) => {
  return (
    <Layout.Row
      align
      py={14}
      px={18}
      radius={16}
      bg="destructiveXLight"
      border={[1, 'solid', 'destructive']}
      style={{ gap: 16 }}
    >
      <Layout.Column
        center
        radius={10}
        style={{
          width: 36,
          height: 36,
          backgroundColor: theme.colors.destructive,
          flexShrink: 0,
        }}
      >
        <Icon name="warning" size={18} color={theme.colors.white} />
      </Layout.Column>
      <Layout.Column grow>
        <OpenSans.Primary weight="bold-700" size="s-16" color="destructive">
          {title}
        </OpenSans.Primary>
        <Spacer.Vertical size={2} />
        <OpenSans.Primary size="xs-12">{description}</OpenSans.Primary>
      </Layout.Column>
      <Button.Primary content={ctaLabel} onClick={onPress} />
    </Layout.Row>
  );
};
